
<form [nbSpinner]="loading"
nbSpinnerStatus="danger"
nbSpinnerSize="large"
nbSpinnerMessage="Actualizando entidades...">
<div class="row">
<div class="col-md-12">
  <nb-card>
    <nb-card-header>
      <nav class="navbar navigation">
        <span><nb-icon icon="globe"></nb-icon> Importar Entidades</span>
        <button nbButton status="primary" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
        </button>

      </nav>

    </nb-card-header>

    <nb-card-body>
      <div class="row">
        <div class="col-sm-3">
          <div class="form-group">
<!--
            <nb-select placeholder="compañía" fullWidth name="role" [(ngModel)]="selectedCompany">
              <nb-option [value]="item.id" *ngFor="let item of companies">{{item.name}}</nb-option>
            </nb-select>
          -->
          <angular2-multiselect [data]="companies" 
          [(ngModel)]="selectedCompany" 
          [settings]="settings">
        </angular2-multiselect>          
      </div>
        </div>
        <div class="col-sm-3">
          <button nbButton status="primary" (click)="generarExcel()">Generar Excel</button>
        </div>
        <div class="col-sm-3">
          <div class="form-group">

            <input type="file" nbInput fullWidth id="excel" name="excel" (change)="actualizarArchivo($event.target.files)"/>
          </div>
        </div>
        <div class="col-sm-3">
          <button nbButton status="primary" *ngIf="entitiesToUpload" (click)="importarExcel()">Importar Excel</button>
        </div>
      </div>
      <nb-card status="success">
        <nb-card-header>Consejos de utilización</nb-card-header>
        <nb-card-body>
          <p>Para generar un excel vacío ( a modo de plantilla) no seleccione ninguna compañía y clice en Generar</p>
          <p>Cuando importe entidades, elimine de la excel aquellas filas que no desee modificar</p>
          <p>Para añadir nuevas entidades deje vacía la celda correspondiente de la columna <b>ID</b></p>
          <p>Para eliminar una entidad rellene la celda correspondiente de la columna <b>Inactivo en</b></p>
          <p>La actualización en lote de entidades es un proceso asíncrono que se ejecuta en servidor. Desde aquí no se confirma el éxito de la operación. Para ello puede generar el excel de la misma compañía pasados unos segundos. </p>
        </nb-card-body>
      </nb-card>




    </nb-card-body>
  </nb-card>
</div>



</div>

</form>



